import dayjs from 'dayjs';
import { IAgreement } from 'app/shared/model/agreement.model';
import { InvoiceStatus } from 'app/shared/model/enumerations/invoice-status.model';
import { InvoiceType } from 'app/shared/model/enumerations/invoice-type.model';

export interface IInvoice {
  id?: number;
  sumFixedMonthlyPrice?: number | null;
  startDate?: dayjs.Dayjs | null;
  endDate?: dayjs.Dayjs | null;
  invoiceStatus?: keyof typeof InvoiceStatus | null;
  invoiceType?: keyof typeof InvoiceType | null;
  createdTimestamp?: dayjs.Dayjs | null;
  invoiceNumber?: string;
  relation?: string | null;
  description?: string | null;
  agreement?: IAgreement | null;
}

export const defaultValue: Readonly<IInvoice> = {};
